import AnimationClip from '../AnimationClip';
import { Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import UITextComponent from '../../../Component/UI/Text';
import { delay } from '../../../Utility/Task/TaskQueue';
import TextComponent from '../../../Component/Render/Text';

export interface ICounterMeta {
    startValue: number;
    finalValue: number;
    duration: number;
    delay?: number;
    onUpdateOverride?: () => void;
}

export class Counter extends AnimationClip {
    private value: number;
    private textComponent: UITextComponent | TextComponent;
    private onUpdateOverride?: (count: number) => void;

    public *execute(
        gameObject: GameObject,
        meta?: ICounterMeta
    ): IterableIterator<number> {
        try {
            this.onUpdateOverride =
                meta.onUpdateOverride ||
                (() => {
                    this.textComponent.text = this.value.toFixed(0);
                });

            this.value = meta.startValue;
            this.textComponent = gameObject.hasComponent(UITextComponent)
                ? gameObject.getComponent(UITextComponent)
                : gameObject.getComponent(TextComponent);

            this.onUpdateOverride(this.value);

            const delayTime: number = meta.delay || 0;

            const tween: Tween = this.getTween(this);
            tween.to({ value: meta.finalValue }, meta.duration);

            yield* delay(delayTime);

            yield* this.startTween(tween);
        } catch (e) {
            console.log('animation failed', e);
        }
    }

    public update(): void {
        super.update();
        this.onUpdateOverride(this.value);
    }
}
